import { render, staticRenderFns } from "./curriculumStatistics.vue?vue&type=template&id=65310ff0"
import script from "./curriculumStatistics.vue?vue&type=script&lang=js"
export * from "./curriculumStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65310ff0')) {
      api.createRecord('65310ff0', component.options)
    } else {
      api.reload('65310ff0', component.options)
    }
    module.hot.accept("./curriculumStatistics.vue?vue&type=template&id=65310ff0", function () {
      api.rerender('65310ff0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/course/curriculumStatistics.vue"
export default component.exports